import dayjs from "dayjs"
import PortalUserRoleTypes from "src/pages/hr/Types/PortalUserRoleTypes"

const portalUserRoleBoilerplate: PortalUserRoleTypes = {
    PortalUserRoleId: null,
    UserId: -1,
    PortalRoleId: -1,
    CreatedDate: dayjs().format(),
    CreatedBy: null,
    ModifyDate: null,
    ModifiedBy: null,
    DeletedDate: null,
    DeletedBy: null,
    DisabledDate: null,
    DisabledBy: null,
    View: false,
    Edit: false
}

export default portalUserRoleBoilerplate